<template>
  <BaseCustomizeMetal componentCode="AR" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAR",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 68px;
    left: 147px;
    @include betweenTableTablePro {
      top: 34px;
      left: 93px;
    }
    @include table {
      top: 20px;
      left: 65px;
    }
    @include phone {
      top: 10px;
      left: 50px;
    }
  }
  .templeName {
    height: 28px;
    width: 130px;
    .textContainer {
      width: 130px;
    }
  }
  .godName {
    width: 220px;
    height: 72px;
    .textContainer {
      width: 220px;
    }
  }
  .gift {
    width: 171px;
    height: 39px;
    .textContainer {
      width: 171px;
    }
  }
}
</style>
